<template>
  <v-layout row justify-center>
    <CModal :show.sync="dialog" :title="dialogTitle" max-width="650px" scrollable id="conditions-dialog">
        <v-progress-linear v-if="processing" :style="{ margin: 0 }" :indeterminate="true"></v-progress-linear>
        <v-container fill-height fluid :class="$style['card-container']">
          <v-layout nowrap>
            <v-flex>
              <v-card outlined :class="$style['card-content']">
                <v-card-text :class="$style['card-text']">
                  <CListGroup>
                    <template v-if="entity.conditions !== null">
                      <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="entity.conditions.user_type !== null">
                        会員属性：{{optionName('common/user_types', entity.conditions.user_type)}}
                      </CListGroupItem>
                      <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="entity.conditions.sex !== null">
                        性別：{{optionName('common/genders', entity.conditions.sex)}}
                      </CListGroupItem>
                      <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="entity.conditions.birth_date !== null">
                        生年月日：{{entity.conditions.birth_date}}
                      </CListGroupItem>
                      <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="entity.conditions.large_location !== null">
                        店舗所在地(大)：{{optionName('common/large_locations', entity.conditions.large_location)}}
                      </CListGroupItem>
                      <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="entity.conditions.medium_location !== null">
                        店舗所在地(中)：{{optionName('common/medium_locations', entity.conditions.medium_location)}}
                      </CListGroupItem>
                      <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="entity.conditions.biz_large_category !== null">
                        店舗業態(大)：{{optionName('common/biz_large_categories', entity.conditions.biz_large_category)}}
                      </CListGroupItem>
                      <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="entity.conditions.biz_medium_category !== null">
                        店舗業態(中)：{{optionName('common/biz_medium_categories', entity.conditions.biz_medium_category)}}
                      </CListGroupItem>
                      <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="entity.conditions.business_scale !== null">
                        店舗規模(店舗数)：{{optionName('common/business_scales', entity.conditions.business_scale)}}
                      </CListGroupItem>
                      <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="entity.conditions.business_area !== null">
                        主要店舗展開エリア：{{optionName('common/business_areas', entity.conditions.business_area)}}
                      </CListGroupItem>
                      <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="entity.conditions.lunch_menu !== null">
                        ランチ営業有無：{{optionName('common/lunch_menus', entity.conditions.lunch_menu)}}
                      </CListGroupItem>
                      <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="entity.conditions.plan_num !== null">
                        会員状態：{{optionName('common/plan_nums', entity.conditions.plan_num)}}
                      </CListGroupItem>
                      <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="entity.conditions.user_ids !== null">
                        ユーザID：{{entity.conditions.user_ids}}
                      </CListGroupItem>
                      <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="entity.conditions.logged_in_at !== null">
                        最終ログイン日時：{{entity.conditions.logged_in_at}}
                      </CListGroupItem>
                    </template>
                  </CListGroup>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      <template #footer>
        <CButton
                :class="$style['reset-dialog-btn']"
                color="primary"
                @click="dialog = false"
        >閉じる</CButton>
      </template>
    </CModal>
  </v-layout>
</template>

<script>
export default {
  props: {
  },
  data() {
    return {
      resourceName: 'push_advertisments'
    };
  },
  watch: {
    dialog(show) {
      const vm = this;
      if (show) {
        this.$store.dispatch(`${this.resourceName}/entity/show`, {
          pk: this.pk
        });
      }
    },
    isLoading(value) {
      if (value) {
        // ローディングマスクを差し込む
        this.$nextTick(() => {
          const overlayHtml = '<div id="conditions-dialog-overlay" class="v-overlay v-overlay--absolute v-overlay--active theme--dark" style="z-index: 5;"><div class="v-overlay__scrim" style="opacity: 0.46; background-color: rgb(33, 33, 33); border-color: rgb(33, 33, 33);"></div><div class="v-overlay__content"><div role="progressbar" aria-valuemin="0" aria-valuemax="100" class="v-progress-circular v-progress-circular--indeterminate" style="height: 64px; width: 64px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="21.333333333333332 21.333333333333332 42.666666666666664 42.666666666666664" style="transform: rotate(0deg);"><circle fill="transparent" cx="42.666666666666664" cy="42.666666666666664" r="20" stroke-width="2.6666666666666665" stroke-dasharray="125.664" stroke-dashoffset="125.66370614359172px" class="v-progress-circular__overlay"></circle></svg><div class="v-progress-circular__info"></div></div></div></div>';
          const modal = document.getElementById('conditions-dialog');
          if (modal) {
            const contents = modal.getElementsByClassName('modal-content');
            if (contents.length) {
              contents[0].insertAdjacentHTML('beforebegin', overlayHtml);
            }
          }
        });
      } else {
        const overlay = document.getElementById('conditions-dialog-overlay');
        if (overlay) {
          overlay.remove();
        }
      }
    },
    "entity.conditions.large_location": {
      handler(value) {
        if (value !== null) {
          this.$store.dispatch(
            `common/medium_locations/options/index`,
            value
          );
        }
      }
    },
    "entity.conditions.biz_large_category": {
      handler(value) {
        if (value !== null) {
          this.$store.dispatch(
            `common/biz_medium_categories/options/index`,
            value
          );
        }
      }
    }
  },
  computed: {
    pk() {
      return this.$store.getters[this.resourceName + "/entity/conditionsPk"];
    },
    entity() {
      return this.$store.getters[`${this.resourceName}/entity/entity`];
    },
    dialog: {
      get() {
        return this.$store.getters[this.resourceName + "/entity/conditionsOpen"];
      },
      set(value) {
        this.$store.commit(this.resourceName + "/entity/conditionsClose");
      }
    },
    processing() {
      return this.$store.getters[this.resourceName + "/entity/processing"];
    },
    isLoading() {
      return this.$store.getters[this.resourceName + "/entity/isLoading"];
    },
    dialogTitle() {
      return "通知絞り込み条件";
    },
    optionName() {
      return (optionName, value) => {
        const options =
          this.$store.getters[`${optionName}/options/options`] || [];
        return (options.find(v => v.value === value) || {}).label;
      };
    }
  },
  methods: {
  },
  mounted(){
    this.$store.dispatch(`common/user_types/options/index`);
    this.$store.dispatch(`common/genders/options/index`);
    this.$store.dispatch(`common/large_locations/options/index`);
    this.$store.dispatch(`common/biz_large_categories/options/index`);
    this.$store.dispatch(`common/business_scales/options/index`);
    this.$store.dispatch(`common/business_areas/options/index`);
    this.$store.dispatch(`common/lunch_menus/options/index`);
    this.$store.dispatch(`common/plan_nums/options/index`);
  }
};
</script>

<style module lang="scss">
.card-container {
  padding: 0px !important;
  border-bottom: 1px solid #eee;
}
.card-text {
  padding: 10px !important;
}
.card-content {
  overflow-y: auto;
  padding: 8px 0 !important;
  border: none !important;
}
.reset-dialog-btn {
  & > span {
    font-size: 14px !important;
  }
}
</style>
<style scoped lang="scss">
.inquiry-text {
  white-space: pre-wrap;
}
</style>
<style lang="scss">
.v-card__title {
  font-size: 14px !important;
}
</style>
<style lang="scss">
#conditions-dialog {
  .modal-dialog {
    max-width: 650px !important;
  }
}
</style>
